import React, { Component } from 'react';

import CurrencyInput from 'react-currency-input'; //https://github.com/jsillitoe/react-currency-input#readme
import { PercentageOutlined, } from '@ant-design/icons';
import N from '@common/constraints/numbers.contraints';


class PercentageInput extends Component {
  handleChange(evt, maskedValue, floatValue) {
    const { max } = this.props;
    const maximo = parseFloat(max);
    if(floatValue > maximo ){
      floatValue = maximo;
    }else if(maximo === undefined && floatValue > 100){
      floatValue = 100.00;
    }
    this.props.onValueChange && this.props.onValueChange({ maskedValue, floatValue });
  }

  get maxLength() {
    const { max, places } = this.props;
    return max.toLocaleString('pt-BR', { minimumFractionDigits: places }).length;

  }
  get maxLengthDefault() {
    return N.MAX_DECIMAL.toString().length;
  }

  render() {
    const {
      className,
      places,
      allowNegative,
      value,
      onBlur,
      placeHolder,
      disabled,
      title,
      tamanho,
      max,
      onValueChange,
      onKeyDown,
      name,
    } = this.props;

    return (
      <>
        <CurrencyInput
          name={name}
          className={className || 'form-control'}
          decimalSeparator=","
          thousandSeparator=""
          precision={places}
          selectAllOnFocus={true}
          allowNegative={allowNegative}
          value={value === undefined ? null : value}
          onChangeEvent={this.handleChange.bind(this)}
          onBlur={onBlur}
          placeholder={placeHolder}
          disabled={disabled}
          maxLength={max ? this.maxLength : tamanho ? tamanho : this.maxLengthDefault}
          allowEmpty={true}
          title={title}
          onKeyDown={onKeyDown}
        />
        <span className="add-on-suggestion align-self-center ml-n4 position-relative" >
          <PercentageOutlined />
        </span>
      </>
    );
  }
}

PercentageInput.defaultProps = {
  places: 2,
};

export default PercentageInput;
